export default "__VITE_ASSET__KBVJGv8Z__"